<ng-template #dialogContent>
  <div class="modal-container">
  <div [dir]="biService.getDir() ? 'rtl': 'ltr'" class="d-flex justify-content-between pe-2 ps-2 pt-2 header-dialog">
    <h3 class="modal-title p-0" mat-dialog-title>{{Title | translate}}</h3>
    <button class="btn-x" (click)="CloseDialog()">X</button>
  </div>
  <div mat-dialog-content>
    <ng-content></ng-content>
  </div>

  <div mat-dialog-actions class="justify-content-end mb-2">
      <button class="py-1 outline" (click)="CloseDialog()" *ngIf="DisplayCancel">{{"Cancel" | translate}}</button>
      <button class="py-1 primary-btn ms-2" (click)="OK()" *ngIf="DisplayOk" >{{"Ok" | translate}}</button>
  </div>
</div>
</ng-template>